import React, { useEffect, useRef, useState } from 'react';
import * as echarts from 'echarts';
import axios from 'axios';
import './power-generation.css';
import { getToken } from '../../Authentication/get-token';
import { BASE_URL } from '../../../strings';

const GaugePowerGenerator = () => {
  const chartRef = useRef(null);
  const myChart = useRef(null);

  const [powerData, setPowerData] = useState(null);

  useEffect(() => {
    const fetchPowerGen = async () => {
      
        const response = await axios.get(
          `${BASE_URL}emapi/power_generation`,getToken()
        );
      
        setPowerData(response.data);
    
    };

    fetchPowerGen();
  }, []);

  useEffect(() => {
    if (powerData && chartRef.current) {
      if (!myChart.current) {
        myChart.current = echarts.init(chartRef.current);
      }

      const seriesData = powerData.series;

      const option = {
        series: [
          {
            type: seriesData.type,
            center: seriesData.center,
            startAngle: seriesData.startAngle,
            endAngle: seriesData.endAngle,
            min: seriesData.min,
            max: seriesData.max,
            progress: {
              show: seriesData.progress.show,
              width: seriesData.progress.width,
              itemStyle: {
                color: seriesData.progress.itemStyle.color,
              },
              backgroundStyle: {
                color: seriesData.progress.backgroundStyle.color,
              },
            },
            detail: {
              formatter: `${seriesData.data[0].value}%\nPower Generation`,
              offsetCenter: [0, 0],
              textStyle: {
                fontSize: 18,
              },
            },
            axisLine: {
              lineStyle: {
                width: seriesData.axisLine.lineStyle.width,
              },
            },
            axisLabel: {
              show: seriesData.axisLabel.show,
            },
            axisTick: {
              show: seriesData.axisTick.show,
            },
            splitLine: {
              show: seriesData.splitLine.show,
            },
            pointer: {
              show: seriesData.pointer.show,
            },
            data: seriesData.data,
          },
        ],
      };

      myChart.current.setOption(option);
    }
  }, [powerData]);

  return (
    <div className="power-container">
      <div className="chart-holder">
        <div className="chart-container" ref={chartRef}></div>
      </div>

      <div className="power-info">
        <div className="power-inner">
          {powerData?.powerMetrics?.map((metric, index) => (
            <div className="power-metrics" key={`metric-${metric.label}-${index}`}>
              <span>{metric.label}</span>
              <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
                {metric.value}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default GaugePowerGenerator;
